import { render, staticRenderFns } from "./bo-confirmation.vue?vue&type=template&id=40f670ce"
import script from "./bo-confirmation.vue?vue&type=script&lang=js"
export * from "./bo-confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports